// Vendor
import 'semantic-ui-css/components/icon.min.css'
import 'semantic-ui-css/components/transition.min.css'
import 'semantic-ui-css/components/dropdown.min.css'
import 'semantic-ui-css/components/label.min.css'
import Checkbox from 'semantic-ui-checkbox'
import modal from 'bootstrap/js/src/modal'

// Modules
import { fetchResults, buildPostJson } from './functions'

$.fn.dropdown = require('semantic-ui-dropdown')
$.fn.transition = require('semantic-ui-transition')
$.fn.checkbox = Checkbox

function initDropdowns (filterSetKeyPrefix, isActiveFiltering = true) {
  const dropdownConfig = {
    onAdd: function (addedValue, addedText, addedChoice) {
      const type = $(this)[0].getAttribute('id')
      handleFilterSelection(
        filterSetKeyPrefix,
        type,
        addedChoice[0].dataset.value,
        addedChoice[0].dataset.name,
        isActiveFiltering
      )
    },
    onRemove: function (addedValue, addedText, removedChoice) {
      const type = $(this)[0].getAttribute('id')
      handleFilterRemoval(
        filterSetKeyPrefix,
        type,
        removedChoice[0].dataset.value,
        removedChoice[0].dataset.name,
        false,
        isActiveFiltering
      )
    },
    fullTextSearch: 'exact'
  }

  $('#logs').dropdown(dropdownConfig)

  $('#record_status').dropdown(dropdownConfig)

  $('#issue_status').dropdown(dropdownConfig)

  $('#categories').dropdown(dropdownConfig)

  $('#priorities').dropdown(dropdownConfig)

  $('#locations').dropdown(dropdownConfig)

  $('#permission_groups').dropdown(dropdownConfig)

  $('#notification_groups').dropdown(dropdownConfig)

  $('#sites').dropdown(dropdownConfig)

  $('#record_type').dropdown({
    clearable: true,
    forceSelection: false,
    action: function (addedValue, value) {
      if (value === 'CHECKLIST') {
        showChecklistFilterModal()
      } else if (value === 'ISSUE') {
        $(this).dropdown('set selected', addedValue)
        enableIssueOnlyFilters()
        const type = $(this)[0].getAttribute('id')
        handleFilterSelection(
          filterSetKeyPrefix,
          type,
          'ISSUE',
          'ISSUE',
          isActiveFiltering
        )
      } else if (value === 'NOTE') {
        showNoteFilterModal()
      }
    }
  })

  $('#sms_thread_status').dropdown(dropdownConfig)

  // Handle Unsetting record type
  $('#record_type').change(function (e) {
    if (e.target.value === '') {
      handleFilterRemoval(filterSetKeyPrefix, 'record-type', null, null, false, isActiveFiltering)
      enableIssueOnlyFilters()
    }
  })
}

function showChecklistFilterModal () {
  $('#confirm-checklist-filter').modal('show')
}

function showNoteFilterModal () {
  $('#confirm-note-filter').modal('show')
}

$('#checklist-filter-modal-confirm').click((ev) => {
  let filterKeyPrefix = 'issue'
  if (location.pathname === '/dashboard') {
    filterKeyPrefix = 'notable_issues'
  } else if (location.pathname === '/report/records') {
    filterKeyPrefix = 'report'
  }
  filterByChecklistsConfirm(filterKeyPrefix)
})

function filterByChecklistsConfirm (filterSetKeyPrefix, isActiveFiltering = true) {
  $('#record_type').dropdown('set selected', 'CHECKLIST')
  disableIssueOnlyFilters(filterSetKeyPrefix)

  handleFilterSelection(
    filterSetKeyPrefix,
    'record_type',
    'CHECKLIST',
    'CHECKLIST',
    isActiveFiltering
  )
}

$('#note-filter-modal-confirm').click((ev) => {
  let filterKeyPrefix = 'issue'
  let isActiveFiltering = true
  if (location.pathname === '/dashboard') {
    filterKeyPrefix = 'notable_issues'
  } else if (location.pathname === '/report/records') {
    filterKeyPrefix = 'report'
    isActiveFiltering = false
  }
  filterByNotesConfirm(filterKeyPrefix, isActiveFiltering)
})

function filterByNotesConfirm (filterSetKeyPrefix, isActiveFiltering = true) {
  $('#record_type').dropdown('set selected', 'NOTE')
  disableIssueOnlyFilters(filterSetKeyPrefix)

  handleFilterSelection(
    filterSetKeyPrefix,
    'record_type',
    'NOTE',
    'NOTE',
    isActiveFiltering
  )
}

function disableIssueOnlyFilters (filterSetKeyPrefix) {
  clearIssueOnlyFilters(filterSetKeyPrefix)
  $('.issue_only_filter').each(function (index, filter) {
    const itemSelector = '.issue_only_filter#' + filter.id + ' .item'
    $(itemSelector).each(function (index, item) {
      $(item).removeClass('active')
      $(item).removeClass('filtered')
    })

    const labelSelector = '.issue_only_filter#' + filter.id + ' a'
    $(labelSelector).each(function (index, label) {
      $(label).remove()
    })

    $(filter).dropdown('set value', '')
    $(filter).addClass('disabled')
  })

  $('#incomplete-issue-toggle').checkbox('uncheck')
  $('#incomplete-issue-toggle').addClass('disabled')
}

function enableIssueOnlyFilters () {
  $('.issue_only_filter').each(function (index, filter) {
    $(filter).removeClass('disabled')
  })
  $('#incomplete-issue-toggle').removeClass('disabled')
}

function clearIssueOnlyFilters (filterSetKeyPrefix) {
  // issue based filters
  filters[filterSetKeyPrefix + '_filters'].priorities = {}
  filters[filterSetKeyPrefix + '_filters'].categories = {}
  filters[filterSetKeyPrefix + '_filters'].show_incomplete_only = false
  filters[filterSetKeyPrefix + '_filters'].locations = {}

  return filters
}

/**
 * @param filterSetKeyPrefix
 * @param type
 * @param id
 * @param value
 * @param isActiveFiltering
 */
function handleFilterSelection (filterSetKeyPrefix, type, id, value, isActiveFiltering = true) {
  if (isActiveFiltering) {
    $('#loadingIcon').show()
  }

  switch (type) {
    case 'record_status':
      if (id === 'active') {
        filters[filterSetKeyPrefix + '_filters'].active_status = true
      }

      if (id === 'inactive') {
        filters[filterSetKeyPrefix + '_filters'].inactive_status = true
      }
      break

    case 'issue_status':
      filters[filterSetKeyPrefix + '_filters'].issue_statuses[value] = id
      break

    case 'logs':
      filters[filterSetKeyPrefix + '_filters'].logs[value] = id
      break

    case 'priorities':
      filters[filterSetKeyPrefix + '_filters'].priorities[value] = id
      break

    case 'categories':
      filters[filterSetKeyPrefix + '_filters'].categories[value] = id
      selectedCategories.push(id)
      handleChildrenOnAdd(filterSetKeyPrefix, $('div[data-parent-id="' + id + '"], div[data-grandparent-id="' + id + '"]'))
      break

    case 'record_type':
      filters[filterSetKeyPrefix + '_filters'].record_type = id
      break

    case 'locations':
      filters[filterSetKeyPrefix + '_filters'].locations[value] = id
      break

    case 'permission_groups':
      filters[filterSetKeyPrefix + '_filters'].permission_groups[value] = id
      break

    case 'notification_groups':
      filters[filterSetKeyPrefix + '_filters'].notification_groups[value] = id
      break

    case 'sms_thread_status':
      filters[filterSetKeyPrefix + '_filters'].sms_thread_status[value] = id
      break
  }

  filters[filterSetKeyPrefix + '_filters'].page = 1

  if (isActiveFiltering) {
    fetchResults(
      buildPostJson(filters), filterSetKeyPrefix
    )
  }

  const event = new Event('FiltersUpdated')
  document.dispatchEvent(event)
}

/**
 * @param filterSetKeyPrefix
 * @param type
 * @param id
 * @param value
 * @param isLozengeRemoval
 * @param isActiveFiltering
 */
function handleFilterRemoval (filterSetKeyPrefix, type, id, value, isLozengeRemoval, isActiveFiltering = true) {
  if (isActiveFiltering) {
    $('#loadingIcon').show()
  }

  switch (type) {
    case 'page':
      break
    case 'page_limit':
      break

    case 'date_range':
      $('#from-date').datepicker('clearDates')
      $('#to-date').datepicker('clearDates')

      delete filters.user_filters.date_range.from_date
      delete filters.user_filters.date_range.to_date
      break

    case 'from-date':
      $('#from-date').datepicker('clearDates')

      filters[filterSetKeyPrefix + '_filters'].from_date = null
      break

    case 'to-date':
      $('#to-date').datepicker('clearDates')

      filters[filterSetKeyPrefix + '_filters'].to_date = null
      break

    case 'show-incomplete-only':
      $('#incomplete-issue-toggle').checkbox('set unchecked')
      filters[filterSetKeyPrefix + '_filters'].show_incomplete_only = false
      break

    case 'record_status':
      if (id === 'active') {
        filters[filterSetKeyPrefix + '_filters'].active_status = null
      } else if (id === 'inactive') {
        filters[filterSetKeyPrefix + '_filters'].inactive_status = null
      }
      break

    case 'status':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#record_status').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].active_status = null
        filters[filterSetKeyPrefix + '_filters'].inactive_status = null
      } else {
        filters[filterSetKeyPrefix + '_filters'].active_status = null
        filters[filterSetKeyPrefix + '_filters'].inactive_status = null
      }
      break

    case 'issue_status':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#issue_status').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].issue_statuses = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].issue_statuses[value]
      }
      break

    case 'priorities':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#priorities').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].priorities = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].priorities[value]
      }
      break

    case 'logs':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#logs').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].logs = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].logs[value]
      }
      break

    case 'permission_groups':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#permission_groups').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].permission_groups = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].permission_groups[value]
      }
      break

    case 'notification_groups':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#notification_groups').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].notification_groups = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].notification_groups[value]
      }
      break

    case 'categories':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#categories').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].categories = {}
        selectedCategories = []
      } else {
        removeCategoryFilter(filterSetKeyPrefix, id, value)
        handleChildrenOnRemove($('div[data-parent-id="' + id + '"], div[data-grandparent-id="' + id + '"]'))
      }
      break

    case 'locations':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#locations').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].locations = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].locations[value]
      }
      break

    case 'record-type':
      $('.ui.fluid.search.selection.dropdown#record_type').dropdown('clear')
      filters[filterSetKeyPrefix + '_filters'].record_type = null
      break

    case 'sms_thread_status':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#sms_thread_status').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].sms_thread_status = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].sms_thread_status[value]
      }
      break

    case 'hide_disabled':
      if (isLozengeRemoval) {
        $('#hide-disabled-profiles').click()
        filters.user_filters.hide_disabled = false
      } else {
        delete filters.user_filters.hide_disabled[value]
      }
      break
  }

  if (isActiveFiltering) {
    fetchResults(
      buildPostJson(filters), filterSetKeyPrefix
    )
  }

  const event = new Event('FiltersUpdated')
  document.dispatchEvent(event)
}

function handleLozengeFilterRemoval (filterSetKeyPrefix, event, isActiveFiltering = true) {
  if (isActiveFiltering) {
    $('#loadingIcon').show()
  }
  const type = event.target.dataset.filterType

  handleFilterRemoval(filterSetKeyPrefix, type, null, null, true, isActiveFiltering)
}

// Category functions
function handleChildrenOnAdd (filterSetKeyPrefix, el) {
  el.each((key, value) => {
    removePill(value.dataset.value)
    removeCategoryFilter(filterSetKeyPrefix, value.dataset.value, value.dataset.name)
    disableOption(value.dataset.value)
  })
}

function handleChildrenOnRemove (el) {
  el.each((key, value) => {
    enableOption(value.dataset.value)
  })
}

function removeCategoryFilter (filterSetKeyPrefix, id, value) {
  delete filters[filterSetKeyPrefix + '_filters'].categories[value]

  const index = selectedCategories.indexOf(id)
  if (index !== -1) {
    selectedCategories.splice(index, 1)
  }
}

function removePill (id) {
  $('a[data-value="' + id + '"] > .delete').click()
}

function disableOption (id) {
  $('div[data-value="' + id + '"]').addClass('active')
  $('div[data-value="' + id + '"]').addClass('filtered')
}

function enableOption (id) {
  $('div[data-value="' + id + '"]').removeClass('active')
  $('div[data-value="' + id + '"]').removeClass('filtered')
}

export { initDropdowns, handleChildrenOnAdd, handleLozengeFilterRemoval }
